export const MESSAGE_TIME_FORMAT = "E, MMM dd yyyy hh:mm a";
export const MESSAGE_DATE_FORMAT = `E, MMM dd yyyy`;
